import { Entity } from '@ecs/Entity';
import { System } from '@ecs/System';
import { ComponentType } from '@ecs/Component';

export class World {
  private entities: Map<number, Entity> = new Map();
  private systems: System[] = [];
  private entitiesToRemove: Set<number> = new Set();

  addEntity(entity: Entity): void {
    this.entities.set(entity.id, entity);
  }

  removeEntity(entity: Entity): void {
    this.entitiesToRemove.add(entity.id);
  }

  isPendingRemoval(entity: Entity): boolean {
    return this.entitiesToRemove.has(entity.id);
  }

  getEntity(id: number): Entity | undefined {
    return this.entities.get(id);
  }

  addSystem(system: System): void {
    system.setWorld(this);
    this.systems.push(system);
  }

  update(deltaTime: number): void {
    // Process entity removals from previous frame
    this.processRemovals();

    // Update all systems
    for (const system of this.systems) {
      system.update(deltaTime);
    }
  }

  private processRemovals(): void {
    for (const id of this.entitiesToRemove) {
      this.entities.delete(id);
    }
    this.entitiesToRemove.clear();
  }

  getEntitiesWithComponents(...components: ComponentType<any>[]): Entity[] {
    const result: Entity[] = [];
    for (const entity of this.entities.values()) {
      if (entity.hasComponents(...components)) {
        result.push(entity);
      }
    }
    return result;
  }

  clear(): void {
    this.entities.clear();
    this.entitiesToRemove.clear();
  }

  getEntityCount(): number {
    return this.entities.size;
  }
}